module.exports = __webpack_public_path__ + "images/CallAnalytics-d3c14ec5fdfe705e7e37c29969ab5824.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/screenshots/CallAnalytics.png
// module id = X3XX
// module chunks = 0